<template>
  <div class="container">


    <!-- 左侧 -->
    <div class="left">

      <!-- 照片 -->
      <div class="pic">
        <!-- 上方 -->
        <div class="pics">
          <img :src="a01109" v-if="BasicsInfo.zdyxa0106">
            <span class="name">姓名：{{named}}</span>
            <span class="date">更新时间：{{BasicsInfo.updatetime}}</span>
        </div>
        <!-- 下面 -->
        <ul>
          <li @click="visible=true">更新照片</li>
          <li @click="queryPersonInfo">预览</li>
          <li @click="download">下载</li>
        </ul>
      </div>

      <!-- 简历 -->
      <div class="jianli">
        <h4>我的简历</h4>
        <ul>
          <li @click="step=1" :style="step==1? objC : ''">人员基本信息</li>
          <li @click="step=2" :style="step==2? objC : ''">学习经历</li>
          <li @click="step=3" :style="step==3? objC : ''">工作或实习经历</li>
          <li @click="step=4" :style="step==4? objC : ''">家庭成员情况</li>
          <li @click="step=5" :style="step==5? objC : ''">应届毕业生信息</li>
          <li @click="step=6" :style="step==6? objC : ''">社会招聘信息</li>
        </ul>
      </div>

    </div>



    <!-- 右侧 -->
    <div class="right">

      <!-- 基本人员信息 -->
       <div v-show="step==1">
         <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">人员基本信息</div>
        </div>
        <!-- 下方内容 -->

        <div :class="['messages',{'msgpc':ifPhone}]">

          <a-form-model ref="baseRef" :rules="baseRules" :model="BasicsInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12">
              <a-form-model-item label="姓名" prop="a0101">
              <a-input :maxLength="20" v-model="BasicsInfo.a0101" style="width: 220px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="性别" prop="a0104">
                 <a-select allowClear  v-model="BasicsInfo.a0104" style="width: 220px">
                  <a-select-option v-for="(item,i) in sexList" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12">
              <a-form-model-item label="民族" prop="a0117">
               <a-select allowClear  v-model="BasicsInfo.a0117" style="width: 220px">
                  <a-select-option v-for="(item,i) in nations" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="政治面貌" prop="a0141">
                 <a-select allowClear  v-model="BasicsInfo.a0141" style="width: 220px">
                  <a-select-option v-for="(item,i) in Political" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
               <a-form-model-item label="出生日期" prop="a0107">
                 <a-date-picker :inputReadOnly="true" show-tiem type="date" placeholder="出生日期"  v-model="BasicsInfo.a0107" style="width: 220px"></a-date-picker>
               </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="身高" prop="a0108">
                  <a-input :maxLength="6" @keyup.native="proving2($event)" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"  v-model="BasicsInfo.a0108" style="width: 200px"></a-input>
                  <span class="cm">cm</span>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
               <a-form-model-item label="体重" prop="a01101">
                  <a-input :maxLength="6" @keyup.native="proving2($event)" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')" v-model="BasicsInfo.a01101" style="width: 200px"></a-input>
                  <span class="cm">kg</span>
                </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="婚姻状态" prop="a0131">
                 <a-select allowClear  v-model="BasicsInfo.a0131" style="width: 220px">
                  <a-select-option v-for="(item,i) in marriage" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>


             <a-row>
             <a-col :span="12">
               <a-form-model-item label="身份证号" prop="a0184">
                  <a-input :maxLength="25" @keyup.native="proving2($event)" v-model="BasicsInfo.a0184" style="width: 220px"></a-input>
                </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="籍贯" prop="a0111a">
                 <a-input :maxLength="20" v-model="BasicsInfo.a0111a" style="width: 220px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
              <a-form-model-item  label="健康状况" prop="a0127a">
                 <a-select allowClear  v-model="BasicsInfo.a0127a" style="width:  528px">
                  <a-select-option v-for="(item,i) in healthy" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
               <a-col :span="12">
              <a-form-model-item  label="特长" prop="a01102">
                <a-input :maxLength="25" v-model="BasicsInfo.a01102" style="width:  528px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>


             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="兴趣爱好" prop="a01103">
                <a-input :maxLength="25" v-model="BasicsInfo.a01103" style="width:  528px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>



            <a-row>
             <a-col :span="12">
              <a-form-model-item label="移动电话" prop="zdyxa0145">
              <a-input :maxLength="20" onkeyup="this.value=this.value.replace(/[^\d]/g,'')" v-model="BasicsInfo.zdyxa0145" style="width: 220px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="住址电话" prop="a0151a">
                 <a-input :maxLength="20" onkeyup="this.value=this.value.replace(/[^\d.-]/g,'')" v-model="BasicsInfo.a0151a" style="width: 220px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
              <a-form-model-item label="电子邮箱" prop="a0109">
              <a-input :maxLength="20"  v-model="BasicsInfo.a0109" style="width: 220px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="邮政编码" prop="zdyxa0108">
                 <a-input :maxLength="20"  v-model="BasicsInfo.zdyxa0108" style="width: 220px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>



             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="通信地址" prop="a01107">
                <a-input :maxLength="60"  v-model="BasicsInfo.a01107" style="width: 528px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>

          <div class="mb-20">
             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="现住址" prop="a0110">
                <a-input :maxLength="60"  v-model="BasicsInfo.a0110" style="width: 528px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>
          </div>

          </a-form-model>

        </div>
        
        <div class="btns">
          <button @click="updateBasicInfo">保存</button>
        </div>

      </div>

      <!-- 学习经历 -->
      <div v-show="step==2">
        <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">学习经历</div>
        </div>
        <!-- 下方内容 -->
        <div class="messages">
            <div class="remarks">
              备注 : 必填，从大学起填，最后一条为系统提取最高学历
            </div>
             <a-table :columns="studyColumns" :data-source="studyListDate"  :pagination="false">

                <template slot="cz" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addStudy(record)"/>
                   <a-button type="primary" shape="circle" icon="delete" @click="deleteLearningExperience(record)"/>
                  </div>
                 </template>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addStudy({})">+</div>
               <button @click="addStudy({})">新增</button>
             </div>
        </div>
      </div>

      <!-- 工作或实习经历 -->
      <div v-show="step==3">
         <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">工作或实习经历</div>
        </div>
        <!-- 下方内容 -->
        <div class="messages">
             <a-table :columns="JobColums" :data-source="JobListDate"  :pagination="false">

                <span slot="todo" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addJob(record)" />
                   <a-button type="primary" shape="circle" icon="delete"  @click="deleteWorkExperience(record)"/>
                  </div>
                 </span>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addJob({})">+</div>
               <button @click="addJob({})">新增</button>
             </div>
        </div>
      </div>

      <!-- 家庭成员 -->
      <div v-show="step==4">
          <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">家庭成员情况</div>
        </div>
        <!-- 下方内容 -->
         <div class="remarks">
              备注 : 父母信息必填，有特殊情况可在“工作单位及职务”备注说明
        </div>
        <div class="messages">
             <a-table :columns="FamilyColums" :data-source="FamilyListDate"  :pagination="false">

                <span slot="todo" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addFM(record)" />
                   <a-button type="primary" shape="circle" icon="delete" @click="deleteFamilyNumber(record)"/>
                  </div>
                 </span>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addFM({})">+</div>
               <button @click="addFM({})">新增</button>
             </div>
        </div>
      </div>

      <!-- 应届毕业生信息 -->
      <div v-show="step==5">
          <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">应届生毕业信息</div>
        </div>
        <!-- 下方内容 -->
        <div class="remarks">
             备注 : 仅为应届毕业生填写
        </div>
        <div :class="['messages',{'msgpc':ifPhone}]">


          <a-form-model ref="studentRef" :rules="StudentRules" :model="StudentInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="生源地" prop="a0186">
              <a-input :maxLength="20" v-model="StudentInfo.a0186" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="学校所在城市" prop="a01110">
                <a-input :maxLength="20" v-model="StudentInfo.a01110" style="width: 180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="英语等级六级成绩" prop="a01111">
              <a-input :maxLength="20" v-model="StudentInfo.a01111" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="是否委培生" prop="a01112">
                 <a-checkbox-group v-model="StudentInfo.a01112">
                   <a-checkbox value="1" name="type">

                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12" :offset="1">
               <a-form-model-item label="是否定向生" prop="a01113">
                 <a-checkbox-group v-model="StudentInfo.a01113">
                   <a-checkbox value="1" name="dxs">

                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="是否计划外招生" prop="a01114">
                 <a-checkbox-group v-model="StudentInfo.a01114">
                   <a-checkbox value="1" name="wzs">

                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="15">
              <a-form-model-item  label="担任学生干部情况" prop="a0191">
                <a-input :maxLength="30" v-model="StudentInfo.a0191" style="width: 506px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
               <a-col :span="15">
              <a-form-model-item  label="学校通讯地址" prop="a01116">
                <a-input :maxLength="30" v-model="StudentInfo.a01116" style="width: 506px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>

            <a-row>
              <a-col :span="15">
              <a-form-model-item  label="学校邮政编码" prop="a01117">
                <a-input :maxLength="30" v-model="StudentInfo.a01117" style="width: 506px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>




            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="院系工作主管老师" prop="a01118">
              <a-input :maxLength="20" v-model="StudentInfo.a01118" style="width:180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="院系主管老师电话" prop="a01119">
                  <a-input :maxLength="20" v-model="StudentInfo.a01119" style="width:180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="奖惩及学术科研成果" prop="a01115">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="StudentInfo.a01115" style="width:506px"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>


          </a-form-model>

        <div class="btns">
          <button @click="updateYjbysInfo">保存</button>
        </div>

        </div>
      </div>

      <!-- 社会招聘信息 -->
      <div v-show="step==6">
        <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">社会招聘信息</div>
        </div>
        <!-- 下方内容 -->
        <div class="remarks">
             备注 : 为社会招聘人员填写
        </div>

        <div :class="['messages',{'msgpc':ifPhone}]">


          <a-form-model ref="sociaRef" :rules="SocialRules" :model="SocialInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="户籍所在地" prop="a0181a">
              <a-input :maxLength="20" v-model="SocialInfo.a0181a" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="档案所在地" prop="zdyxa0105">
                <a-input :maxLength="20" v-model="SocialInfo.zdyxa0105" style="width: 180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="首次参加工作时间" prop="zdyxa123">
              <a-date-picker :inputReadOnly="true" :disabled-date="disabledzdyxa123Date" placeholder="首次参加工作时间" show-tiem type="date" v-model="SocialInfo.zdyxa123" style="width: 180px"></a-date-picker>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                 <a-form-model-item label="现工作状态" prop="a01121">
              <a-input :maxLength="20" v-model="SocialInfo.a01121" style="width: 180px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="现工作单位" prop="a01122">
              <a-input :maxLength="20" v-model="SocialInfo.a01122" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
              <a-form-model-item label="入职现工作时间" prop="a01123">
              <a-date-picker :inputReadOnly="true" :disabled-date="disableda01123Date" placeholder="入职时间" show-tiem type="date" v-model="SocialInfo.a01123" style="width: 180px"></a-date-picker>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="现担任职务" prop="a01124">
              <a-input :maxLength="20" v-model="SocialInfo.a01124" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
              <a-form-model-item label="任职时间" prop="a0113">
              <a-date-picker :inputReadOnly="true"  placeholder="任职时间" show-tiem type="date" v-model="SocialInfo.a0113" style="width: 180px"></a-date-picker>
              </a-form-model-item>
              </a-col>
            </a-row>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="工作技能" prop="a01125">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="SocialInfo.a01125" placeholder="若没有就填无（300字以内）"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="奖惩情况" prop="a01126">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="SocialInfo.a01126" placeholder="若没有就填无（300字以内）"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>




          </a-form-model>


        <div class="btns">
          <button @click="updateShzpInfo">保存</button>
        </div>

        </div>
      </div>

    </div>

    <a-modal
      title="上传照片"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确认"
    >

      <!-- <img class="picc" :src="filePag" alt="未选择照片" id="img3">

      <p>提示：请选择照片上传。</p>

      <input type="file" id="file" class="filepath" @change="picChange($event)"> -->


  <div>
    <a-upload
    name="picture"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :action="actionUrl"
    :before-upload="beforeUpload"
    :headers="requestHeaders"
    @change="handleChange"
    :data="data"
  >
    <img class="imgAvatar" v-if="imageUrl" :src="imageUrl" alt="avatar" />
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
    </a-upload>
    请上传png格式的文件

  </div>


    </a-modal>

    <jtcy :FMVisible.sync="FMVisible" :FamilyListDate = "FamilyListDate" :FMInfo="FMInfo" @updt="updt2"></jtcy>
    <ssjl :JobVisible.sync="JobVisible" :jobInfo="JobInfo" @updt="updt3"></ssjl>
    <xxjl :studyVisible.sync="studyVisible" :studyInfo="studyInfo" @updt="updt1"></xxjl>
  </div>
</template>


<script>

var configLink = require('../../../../config/index')

import jtcy from '../../zkzw/compos/jtcy.vue'
import ssjl from '../../zkzw/compos/ssjl.vue'
import xxjl from '../../zkzw/compos/xxjl.vue'

import moment from 'moment'


import  {  Base64  }  from  'js-base64'
import  {  encode ,  decode  }  from  'js-base64' ;
import { config } from '../../encryptionConfig.js'


function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export default {
  components:{
    jtcy,ssjl,xxjl
  },
  data(){
    //验证身份证的正则表达式
    let validateSfz = (rule, value, callback) => {
      var reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (!reg.test(value)) {
        callback(new Error('身份证号格式错误'));
      }else{
        callback();
      }
    }
  //移动电话
    let validateYddh = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    //电子邮箱
    let validateDzyx = (rule, value, callback) => {
      var reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!reg.test(value)) {
        callback(new Error('电子邮箱格式错误'));
      }else{
        callback();
      }
    }

    //邮政编码
    let validateYzbm = (rule, value, callback) => {
      var reg =  /^[0-9]\d{5}(?!\d)$/;
      if (!reg.test(value)) {
        callback(new Error('邮政编码格式错误'));
      }else{
        callback();
      }
    }

    //不能为负数
    let validatefs = (rule, value, callback) => {
      var reg =   /^\+?((0|([1-9]+\d*))|((0\.\d+)|([1-9]+\d*\.\d+)))$/;
      if (!reg.test(value)) {
        callback(new Error('格式不正确'));
      }else{
        callback();
      }
    }

    //身高小于250
    let validatesg= (rule, value, callback) => {
      if (value>250) {
        callback(new Error('输入的身高过高'));
      }else{
        callback();
      }
    }

    //体重小于200Kg
    let validatetz= (rule, value, callback) => {
      if (value>200) {
        callback(new Error('您输入的体重过高'));
      }else{
        callback();
      }
    }

    //身份证和出生日期是否匹配
    let validatesfrq= (rule, value, callback) => {
      var date = value.slice(6,14)
      var newdate = date.slice(0,4)+'-'+date.slice(4,6)+'-'+date.slice(6,8)
      // this.a0107
      var nowD=moment(this.BasicsInfo.a0107).format('YYYY-MM-DD');
      if (newdate!=nowD) {
        callback(new Error('出生日期不一致'));
      }else{
        callback();
      }
    }

    //身份证和性别是否匹配
    let validatesfxb= (rule, value, callback) => {
      var date = value.slice(-2,-1)
      var sex = ''
      var sex2 = ''

      if (date%2 == 1){
        sex = '男'
      } else if(date%2 == 0){
        sex = '女'
      }

      if (this.BasicsInfo.a0104 == 1){
        sex2 = '男'
      } else if(this.BasicsInfo.a0104 == 2){
        sex2 = '女'
      } else if(this.BasicsInfo.a0104 == '男'){
        sex2 = '男'
      } else if(this.BasicsInfo.a0104 == '女'){
        sex2 = '女'
      }

      if (sex!=sex2) {
        callback(new Error('与您填入的性别不一致'));
      }else{
        callback();
      }
    }

    return{
      //头像
      a01109:'',
      requestHeaders: {
        'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN')
      },
      //显示名称
      named:'',

      //要上传的头像
      loading: false,
      imageUrl: '',
      data:{
        // 'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN'),
        // a00:sessionStorage.getItem('aabb'),
        picture:null
      },
      actionUrl:'/dev-api/recruit/resume/updatePhoto',
      //控制三个组件的显示隐藏
      FMVisible:false,
      JobVisible:false,
      studyVisible:false,


      //打开修改学习经历组件要传的数据
      studyInfo:{},

      //打开修改工作经历组件要传的数据
      JobInfo:{},

      //打开修改家庭成员组件要传的数据
      FMInfo:{},


      labelCol: { span: 9 },
      wrapperCol: { span: 10 },

      //上传图片储存数据
      filePag:null,
      //
      files:null,


      visible:false,

      step:1,
      objC: {backgroundColor: '#FFF1DD'},

       //下拉框数据

      // 性别
      sexList:[],
      //民族
      nations: [],
      //政治面貌
      Political:[],
      // 婚姻
      marriage:[],
      //健康状态
      healthy:[],
      //与本人关系
      relation:[],
      //  学历
      educationList:[],
      //学位
      academic:[],
      //教育类型
      Education:[],
      //学制
      system:[],



      // 简历基本信息
      BasicsInfo:{
      },

      // 社会招聘信息信息
      SocialInfo:{},

      // 应届生毕业信息
      StudentInfo:{},








       //学习经历表格数据
      studyListDate:[],
      //学习经历表格头
      studyColumns:[
        {
          title: '入学时间',
          dataIndex: 'a0801',
          key: 'a0801',
        },
        {
          title: '毕业时间',
          dataIndex: 'a0802',
          key: 'a0802',
        },
        {
          title: '学历',
          dataIndex: 'a0803',
          key: 'a0803',
        },
        {
          title: '学位',
          dataIndex: 'a0804',
          key: 'a0804',
        },
        {
          title: '院校',
          dataIndex: 'a0805',
          key: 'a0805',
        },
        {
          title: '学院',
          dataIndex: 'a0806',
          key: 'a0806',
        },
        {
          title: '所学专业',
          dataIndex: 'a0807',
          key: 'a0807',
        },
        {
          title: '教育类型',
          dataIndex: 'a0813',
          key: 'a0813',
        },
        {
          title: '学制',
          dataIndex: 'a0814',
          key: 'a0814',
        },
        {
          title: '操作',
          dataIndex: 'cz',
          key: 'cz',
          scopedSlots: { customRender: 'cz' },
        }
      ],

       //工作或实习经历表格头
      JobColums:[
        {
          title: '起始时间',
          dataIndex: 'a4801',
          key: 'a4801',
        },
        {
          title: '截止日期',
          dataIndex: 'a4802',
          key: 'a4802',
        },
        {
          title: '组织或公司名称',
          dataIndex: 'a4803',
          key: 'a4803',
        },
        {
          title: '工作单位及职务',
          dataIndex: 'a4805',
          key: 'a4805',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
        ],
      //工作或实习经历表格数据
      JobListDate:[],


       //家庭情况表头
      FamilyColums:[
         {
          title: '姓名',
          dataIndex: 'a1501',
          key: 'a1501',
        },
        {
          title: '与本人关系',
          dataIndex: 'a1503',
          key: 'a1503',
        },
        {
          title: '民族',
          dataIndex: 'a1506',
          key: 'a1506',
        },
        {
          title: '政治面貌',
          dataIndex: 'a1504',
          ellipsis: true,
          key: 'a1504',
        },
        {
          title: '联系电话',
          dataIndex: 'a1508',
          ellipsis: true,
          width: 100,
          key: 'a1508',
        },
        {
          title: '工作单位及职务',
          dataIndex: 'a1505',
          ellipsis: true,
          key: 'a1505',
        },
        {
          title: '出生日期',
          dataIndex: 'a1507',
          key: 'a1507',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
      ],
      // 家庭情况表格数据
      FamilyListDate:[],




      // 基础信息校验规则
      baseRules:{
        a0101: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 8, message: '请输入正确的姓名', trigger: 'blur' },
        ],
        a0104: [
          { required: true, message: '请输入性别', trigger: 'blur' },
        ],
        a0117: [
          { required: true, message: '请输入民族', trigger: 'blur' },
        ],
        a0141: [
          { required: true, message: '请输入政治面貌', trigger: 'blur' },
        ],
        a0107: [
          { required: true, message: '请输入出生日期', trigger: 'change' },
        ],
        a0108: [
          { required: true, message: '请输入身高', trigger: 'blur' },
          { validator: validatefs, trigger: 'blur' },
          { validator: validatesg, trigger: 'blur' }
        ],
        a01101: [
          { required: true, message: '请输入体重', trigger: 'blur' },
          { validator: validatefs, trigger: 'blur' },
          { validator: validatetz, trigger: 'blur' }
        ],
        a0131: [
          { required: true, message: '请输入婚姻状态', trigger: 'blur' },
        ],
        a0184: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateSfz, trigger: 'blur' },
          // { validator: validatefs, trigger: 'blur' },
          { validator: validatesfrq, trigger: 'blur' },
          { validator: validatesfxb, trigger: 'blur' }
        ],
        a0111a: [
          { required: true, message: '请输入籍贯', trigger: 'blur' },
        ],
        a0127a: [
        ],
        a01102: [
        ],
        a01103: [
        ],
        zdyxa0145: [
          { required: true, message: '请输入正确号码', trigger: 'blur' },
          { validator: validateYddh, trigger: 'blur' },
        ],
        a0151a: [
        ],
        a0109: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: validateDzyx, trigger: 'blur' }
        ],
        zdyxa0108: [
          { required: true, message: '请输入邮政编码', trigger: 'blur' },
          { validator: validateYzbm, trigger: 'blur' }
        ],
        a01107: [
          { required: true, message: '请输入通讯地址', trigger: 'blur' },
        ],
        a0110: [
        ],

      },

      //应届毕业生信息校验规则
      StudentRules:{
        a0186: [
          { required: true, message: '请输入生源地', trigger: 'blur' },
        ],
      },

      //社会招聘信息校验规则
      SocialRules:{
        a0181a: [
          { required: true, message: '请输入户籍所在地', trigger: 'blur' },
        ],
        zdyxa123: [
          { required: true, message: '请输入首次参加工作时间', trigger: 'change' },
        ],
        a01123: [
          { required: true, message: '请输入入职时间', trigger: 'change' },
        ],
        a0113: [
          { required: true, message: '请输入任职时间', trigger: 'change' },
        ],

      },
      userAgent: 'pc',
      ifPhone: false


    }
  },

  methods:{
    disabledzdyxa123Date(startValue) {
      const endValue = this.SocialInfo.a01123;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disableda01123Date(endValue) {
      const startValue = this.SocialInfo.zdyxa123;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleOk(){
      this.visible=false
    },

    handleCancel(){
      this.imageUrl=''
        this.visible=false
    },

    //打开学习经历框
    addStudy(r){
      var b=JSON.stringify(r);
      if(b === '{}') {
        console.log(1);
      }else{
        r.biaoji=true
      }

      this.studyInfo=r
      console.log(this.studyInfo);
      this.studyVisible=true
    },

    //打开工作经历框
    addJob(r){
      var b=JSON.stringify(r);
      if(b === '{}') {
        console.log("1");
      }else{
        r.biaoji=true
      }

      this.JobInfo=r
      console.log(this.JobInfo);
      this.JobVisible=true
    },

    //打开家庭成员框
    addFM(r){
      var b=JSON.stringify(r);
      if(b === '{}') {
        console.log("1");
      }else{
        r.biaoji=true
      }

      this.FMInfo=r
      console.log(this.FMInfo);
      this.FMVisible=true
    },












    //获取个人简历信息
    getBasicInfo(){
      this.post({
        url:'getBasicInfo',
        data:{
          'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN'),
          a00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        this.named=res.data.a0101
        if(!isNaN((res.data.a0104)*1)){
          this.sexList.map(i=>{
           if(i.DMCOD==(res.data.a0104)*1){
            res.data.a0104= i.DMCPT
          }
          })
        }

        if(!isNaN((res.data.a0117)*1)){
        this.nations.map(i=>{
           if(i.DMCOD==res.data.a0117){
            res.data.a0117= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0141)*1)){
        this.Political.map(i=>{
           if(i.DMCOD==res.data.a0141){
            res.data.a0141= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0131)*1)){
        this.marriage.map(i=>{
           if(i.DMCOD==res.data.a0131){
            res.data.a0131= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0127a)*1)){
        this.healthy.map(i=>{
           if(i.DMCOD==res.data.a0127a){
            res.data.a0127a= i.DMCPT
          }
        })
        }

        // this.BasicsInfo=res.data
        let obj = {}
        for (const key in res.data) {
            obj[key] = res.data[key]
        }
        obj.a0107 = (res.data.a0107!==null && res.data.a0107!==undefined && res.data.a0107!=='') ? moment(res.data.a0107, 'YYYY-MM-DD'):res.data.a0107
        this.BasicsInfo = obj
        // for (const key in res.data) {
        //   if(key !== 'a0107'){
        //     this.BasicsInfo[key] = res.data[key]
        //   }
        // }
        // this.BasicsInfo.zdyxa0106 = res.data.zdyxa0106
        // this.BasicsInfo.updatetime = res.data.updatetime
        // this.BasicsInfo.a0101 = res.data.a0101
        // this.BasicsInfo.a0104 = res.data.a0104
        // this.BasicsInfo.a0117 = res.data.a0117
        // this.BasicsInfo.a0141 = res.data.a0141
        // this.BasicsInfo.a0107 = (res.data.a0107!==null && res.data.a0107!==undefined && res.data.a0107!=='') ? moment(res.data.a0107, 'YYYY-MM-DD'):res.data.a0107
        // this.BasicsInfo.a0108 = res.data.a0108
        // this.BasicsInfo.a01101 = res.data.a01101
        // this.BasicsInfo.a0131 = res.data.a0131
        // this.BasicsInfo.a0184 = res.data.a0184
        // this.BasicsInfo.a0111a = res.data.a0111a
        // this.BasicsInfo.a0127a = res.data.a0127a
        // this.BasicsInfo.a01102 = res.data.a01102
        // this.BasicsInfo.a01103 = res.data.a01103
        // this.BasicsInfo.zdyxa0145 = res.data.zdyxa0145
        // this.BasicsInfo.a0151a = res.data.a0151a
        // this.BasicsInfo.a0109 = res.data.a0109
        // this.BasicsInfo.zdyxa0108 = res.data.zdyxa0108
        // this.BasicsInfo.a01107 = res.data.a01107
        // this.BasicsInfo.a0110 = res.data.a0110
        this.a01109='/dev-api/platservice/fileupload/previewImage?fid='+ this.BasicsInfo.zdyxa0106 + '&BDSOFT-TOKEN=' + sessionStorage.getItem('BDSOFT-TOKEN')
        console.log(this.a01109);
      })
    },

    //获取照片
    // previewImage(){
    //    this.get({
    //     url:'previewImage',
    //     data:{
    //       fid:this.BasicsInfo.zdyxa0106,
    //       responseType:"arraybuffer"
    //     },
    //   },(res)=>{
    //       // let blob = new Blob([res/]);   // 返回的文件流数据
    //       // let url = window.URL.createObjectURL(blob);  // 将他转化为路径
    //       // this.a01109 = url  // 将转换出来的路径赋值给变量，其实和上一步结合就可以
    //       // this.a01109=Base64.encode(res)
    //       // console.log(blob);
    //       // console.log(this.a01109);
    //       // this.a01109=res
    //   })
    // },

    //修改简历基本信息
    updateBasicInfo(){
        // 格式化日期的函数
        function getTargetTime(t){
          var d = t.split(" ")[0],
          h = t.split(" ")[1],
          date = new Date()
          date.setYear(d.split("-")[0])
          date.setMonth(d.split("-")[1] - 1)
          date.setDate(d.split("-")[2])
          return date.getTime()
        }


        this.$refs.baseRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')


        if(typeof(this.BasicsInfo.a0107)=='string'){
          if(getTargetTime(this.BasicsInfo.a0107)>new Date().getTime()) {
            return this.$message.warning('出生日期不能晚于当前时间');
          }
        }else{
          if((this.BasicsInfo.a0107).unix()*1000>new Date().getTime()){
            return this.$message.warning('出生日期不能晚于当前时间');
          }
        }

        //此处还需要做把ant的moment对象转换成字符串格式
        this.BasicsInfo.a0107=moment(this.BasicsInfo.a0107).format('YYYY-MM-DD');

        if(!typeof(this.BasicsInfo.a0104*0)!=='number'){
          this.sexList.map(i=>{
            if(i.DMCPT==this.BasicsInfo.a0104){
              this.BasicsInfo.a0104= i.DMCOD
            }
          })
        }else{
          // this.BasicsInfo.a0104*0+1
        }

        if(!typeof(this.BasicsInfo.a0117*0)!=='number'){
          this.nations.map(i=>{
            if(i.DMCPT==this.BasicsInfo.a0117){
              this.BasicsInfo.a0117= i.DMCOD
            }
          })
        }else{
          // this.BasicsInfo.a0117*0+1
        }

        if(!typeof(this.BasicsInfo.a0141*0)!=='number'){
          this.Political.map(i=>{
            if(i.DMCPT==this.BasicsInfo.a0141){
                this.BasicsInfo.a0141= i.DMCOD
            }
          })
        }else{
          // this.BasicsInfo.a0141*0+1
        }

        if(!typeof(this.BasicsInfo.a0131*0)!=='number'){
          this.marriage.map(i=>{
            if(i.DMCPT==this.BasicsInfo.a0131){
                this.BasicsInfo.a0131= i.DMCOD
            }
          })
        }else{
          // this.BasicsInfo.a0131*0+1
        }

        if(!typeof(this.BasicsInfo.a0127a*0)!=='number'){
          this.healthy.map(i=>{
            if(i.DMCPT==this.BasicsInfo.a0127a){
                this.BasicsInfo.a0127a= i.DMCOD
            }
          })
        }else{
          // this.BasicsInfo.a0127a*0+1
        }

        console.log(this.BasicsInfo);

        this.post({
          url:'updateBasicInfo',
          data:this.BasicsInfo
          },(res)=>{
          console.log(res);
          if(res.code==200){
            this.$message.success('修改简历信息成功')
            this.getBasicInfo()
          }else{
            this.$message.error(res.message)
          }
        })
      });
    },

    //获取社会招聘信息
    getShzpInfo(){
       this.post({
        url:'getShzpInfo',
        data:{
          a00:sessionStorage.getItem('aabb'),
        }
      },(res)=>{
        // this.SocialInfo=res.data

         let obj1 = {}
         for (const key in res.data) {
           obj1[key] = res.data[key]
         }
         obj1.zdyxa123 = (res.data.zdyxa123!==null && res.data.zdyxa123!==undefined && res.data.zdyxa123!=='') ? moment(res.data.zdyxa123, 'YYYY-MM-DD'):res.data.zdyxa123
         obj1.a01123 = (res.data.a01123!==null && res.data.a01123!==undefined && res.data.a01123!=='') ? moment(res.data.a01123, 'YYYY-MM-DD'):res.data.a01123
         obj1.a0113 = (res.data.a0113!==null && res.data.a0113!==undefined && res.data.a0113!=='') ? moment(res.data.a0113, 'YYYY-MM-DD'):res.data.a0113
         this.SocialInfo = obj1
         // for (const key in res.data) {
         //   if(key !== 'zdyxa123' && key !== 'a01123' && key !== 'a0113'){
         //     this.SocialInfo[key] = res.data[key]
         //   }
         // }
         // this.SocialInfo.a0181a =res.data.a0181a
         // this.SocialInfo.zdyxa0105 =res.data.zdyxa0105
         // this.SocialInfo.zdyxa123 =(res.data.zdyxa123!==null && res.data.zdyxa123!==undefined && res.data.zdyxa123!=='') ? moment(res.data.zdyxa123, 'YYYY-MM-DD'):res.data.zdyxa123
         // this.SocialInfo.a01121 =res.data.a01121
         // this.SocialInfo.a01122 =res.data.a01122
         // this.SocialInfo.a01123 =(res.data.a01123!==null && res.data.a01123!==undefined && res.data.a01123!=='') ? moment(res.data.a01123, 'YYYY-MM-DD'):res.data.a01123
         // this.SocialInfo.a01124 =res.data.a01124
         // this.SocialInfo.a0113 =(res.data.a0113!==null && res.data.a0113!==undefined && res.data.a0113!=='') ? moment(res.data.a0113, 'YYYY-MM-DD'):res.data.a0113
         // this.SocialInfo.a01125 =res.data.a01125
         // this.SocialInfo.a01126 =res.data.a01126
      })
    },

    //修改社会招聘信息
    updateShzpInfo(){
       // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])


        return date.getTime()
      }

      this.$refs.sociaRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')

      this.SocialInfo.a00=sessionStorage.getItem('aabb')

      if(typeof(this.SocialInfo.zdyxa123)=='string'){
        if(getTargetTime(this.SocialInfo.zdyxa123)>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      }else{
       if((this.SocialInfo.zdyxa123).unix()*1000>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      }

      if(typeof(this.SocialInfo.a01123)=='string'){
        if(getTargetTime(this.SocialInfo.a01123)>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      }else{
       if((this.SocialInfo.a01123).unix()*1000>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      }


      if(typeof(this.SocialInfo.a0113)=='string'&&(typeof(this.SocialInfo.a01123)=='string')){
         console.log(1);
         if(getTargetTime(this.SocialInfo.a0113)<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
       }else if(typeof(this.SocialInfo.a0113)=='string'){
         console.log(2);
         if(getTargetTime(this.SocialInfo.a0113)<(this.SocialInfo.a01123).unix()*1000) return this.$message.warning('入职时间不能晚于任职时间');
       }else if(typeof(this.SocialInfo.a01123)=='string'){
         console.log(3);
         if((this.SocialInfo.a0113).unix()*1000<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
       }else{
         console.log(4);
         if((this.SocialInfo.a0113).unix()<(this.SocialInfo.a01123).unix()) return this.$message.warning('入职时间不能晚于任职时间');
       }

      //此处还需要做把ant的moment对象转换成字符串格式
      this.SocialInfo.zdyxa123=moment(this.SocialInfo.zdyxa123).format('YYYY-MM-DD');
      this.SocialInfo.a0113=moment(this.SocialInfo.a0113).format('YYYY-MM-DD');
      this.SocialInfo.a01123=moment(this.SocialInfo.a01123).format('YYYY-MM-DD');


      console.log(this.SocialInfo);

       this.post({
        url:'updateShzpInfo',
        data:this.SocialInfo
      },(res)=>{
         if(res.code==200){
          this.$message.success('更新社会招聘信息成功')
        }else{
          this.$message.error(res.message)
        }
      })
      })
    },

    //获取应届毕业生信息
    getYjbysInfo(){
       this.post({
        url:'getYjbysInfo',
        data:{
          a00:sessionStorage.getItem('aabb'),
        }
      },(res)=>{
        // 返回数据为字符串，这里将其转换为数组
        if(res.data.a01112!=null){
          res.data.a01112=[res.data.a01112]
        }
         if(res.data.a01113!=null){
          res.data.a01113=[res.data.a01113]
        }
         if(res.data.a01114!=null){
          res.data.a01114=[res.data.a01114]
        }
        this.StudentInfo=res.data
      })
    },

    //修改应届毕业生信息
    updateYjbysInfo(){
      this.$refs.studentRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      this.StudentInfo.a00=sessionStorage.getItem('aabb')
      console.log(this.StudentInfo);
      //表单里多选框内容为数组，这里将其转换为字符串再上传

      var ddd=JSON.stringify(this.StudentInfo)
      var eee=JSON.parse(ddd)
      var dist=eee

       dist.a01112=null
       dist.a01113=null
       dist.a01114=null
      if(this.StudentInfo.a01112){
        dist.a01112=this.StudentInfo.a01112[0]
      }else{
        dist.a01112=null
      }

      if(this.StudentInfo.a01113){
        dist.a01113=this.StudentInfo.a01113[0]
      }else{
        dist.a01113=null
      }

      if(this.StudentInfo.a01114){
        dist.a01114=this.StudentInfo.a01114[0]
      }else{
        dist.a01114=null
      }


      console.log(dist);
      if((!/^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/.test(this.StudentInfo.a01119)) && !this.StudentInfo.a01119==''){
        return this.$message.error('主管老师电话格式不正确')
      }

      if((!/^[0-9]\d{5}(?!\d)$/.test(this.StudentInfo.a01117)) && !this.StudentInfo.a01117==''){
        return this.$message.error('邮政编码格式不对')
      }

       this.post({
        url:'updateYjbysInfo',
        data:dist
      },(res)=>{
        if(res.code=200){
          this.$message.success('更新应届生毕业信息成功')
        }else{
          this.$message.error(res.message)
        }
      })
      })
    },








    //获取学习经历信息
    getLearningExperienceByA00(){
       this.post({
        url:'getLearningExperienceByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
      if(res.code=200){
      res.data.map(i=>{
        this.educationList.map(j=>{
          if(i.a0803==j.DMCOD){
            i.a0803=j.DMCPT
          }
        })
      })

      res.data.map(i=>{
        this.academic.map(j=>{
          if(i.a0804==j.DMCOD){
            i.a0804=j.DMCPT
          }
        })
      })

      res.data.map(i=>{
        this.Education.map(j=>{
          if(i.a0813==j.DMCOD){
            i.a0813=j.DMCPT
          }
        })
      })

      res.data.map(i=>{
        this.system.map(j=>{
          if(i.a0814==j.DMCOD){
            i.a0814=j.DMCPT
          }
        })
      })
          this.studyListDate=res.data
        }
      })
    },
    //删除学习经历信息
    deleteLearningExperience(id){
      var that=this
      var ids=id
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
          url:'deleteLearningExperience',
          data:{
            recordId:ids.recordid
          }
        },(res)=>{
          if(res.code=200){
            that.$message.success('删除学习经历成功')
            that.getLearningExperienceByA00()
          }else{
          this.$message.error(res.message)
          }
        })
        },
        onCancel() {},
      });

    },
    //更新学习经历数据后刷新
    updt1(){
      this.getLearningExperienceByA00()
    },








    //获取家庭成员信息
    getFamilyNumbersByA00(){
       this.post({
        url:'getFamilyNumbersByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        console.log(res);
        if(res.code=200){
          //此处修改下拉框数据 为真实值
      //  if(!isNaN((res.data.a1503)*1)){
      //     this.relation.map(i=>{
      //      if(i.DMCOD==(res.data.a1503)*1){
      //       res.data.a1503= i.DMCPT
      //     }
      //   })
      // }
      // res.data.map(i=>{
      //   this.relation.map(j=>{
      //     if(i.a1503==j.DMCOD){
      //       i.a1503=j.DMCPT
      //     }
      //   })
      // })

      // res.data.map(i=>{
      //   this.nations.map(j=>{
      //     if(i.a1506==j.DMCOD){
      //       i.a1506=j.DMCPT
      //     }
      //   })
      // })

      // res.data.map(i=>{
      //   this.Political.map(j=>{
      //     if(i.a1504==j.DMCOD){
      //       i.a1504=j.DMCPT
      //     }
      //   })
      // })


          this.FamilyListDate=res.data
        }
      })
    },
    //删除家庭成员信息
    deleteFamilyNumber(id){

       var that=this
      var ids=id
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
        url:'deleteFamilyNumber',
        data:{
          recordId:ids.recordid
        }
      },(res)=>{
        if(res.code=200){
          that.$message.success('删除家庭成员成功')
          that.getFamilyNumbersByA00()
        }else{
          this.$message.error(res.message)
        }
      })
        },
        onCancel() {},
      });
    },
    //更新家庭成员数据后刷新
    updt2(){
      this.getFamilyNumbersByA00()
    },








    //获取工作经历信息
    getWorkExperienceByA00(){
       this.post({
        url:'getWorkExperienceByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        if(res.code=200){
          this.JobListDate=res.data
        }else{
          this.$message.error(res.message)
        }
      })
    },
    //删除工作经历信息
    deleteWorkExperience(id){

      var that=this
      var ids=id
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
        url:'deleteWorkExperience',
        data:{
          recordId:ids.recordid,
          'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN')
        }

      },(res)=>{
        if(res.code=200){
          that.$message.success('删除工作经历成功')
          that.getWorkExperienceByA00()
        }else{
          this.$message.error(res.message)
        }
      })
      },
        onCancel() {},
      });
    },
    //更新家庭成员数据后刷新
    updt3(){
      this.getWorkExperienceByA00()
    },







    //点击了简历下载
    download(){
      window.open(`/dev-api/report/exportWord/export?theme=none&templateDir=template/preview/%E7%AE%80%E5%8E%86.doc&isDownLoad=1&A00=${sessionStorage.getItem('aabb')}&saveAsFileName=%E7%AE%80%E5%8E%86&BDSOFT-TOKEN=${sessionStorage.getItem('BDSOFT-TOKEN')}&key=${config.key}&encryption=${config.encryption}`)

    },
    // download () {
    //   const param = {
    //     A00:sessionStorage.getItem('aabb'),
    //     templateDir: 'template/preview/%E7%AE%80%E5%8E%86.doc', // 模板路径是从resources目录下开始
    //     isDownLoad: '1', // 下载
    //     'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN'),
    //     saveAsFileName: '简历'// 指定另存为的文件名
    //   }
    //   // 调用导出的方法
    //   exportWord(param)
    // },
    //点击了预览简历
    //画表
    queryPersonInfo(){
      this.post({
          url: 'queryPersonInfo',
          data:{
            A00:sessionStorage.getItem('aabb'),
            baseTable:1
          }
      }, (res) => {
        this.$router.push({path:'/yljl',query: {data:res,fidId:this.BasicsInfo.zdyxa0106}})
      })
    },

    //   //图片改变的时候触发函数
    // picChange(){
    //     var reads = new FileReader();
    //     var f = document.getElementById('file').files[0];
    //     console.log(f);
    //     this.files=f.name


    //     reads.readAsDataURL(f);
    //     var that=this
    //     reads.onload = function(e) {
    //       console.log(this.result);
    //       console.log(f.name);
    //       document.getElementById('img3').src = this.result;
    //       that.filePag=this.result
    //     }

    // },

    // //点击上传照片
    // updatePhoto(){
    //   console.log(this.files);
    //   this.post({
    //     url:'updatePhoto',
    //     data:{
    //       a00:sessionStorage.getItem('aabb'),
    //       picture:this.files
    //     }
    //   },(res)=>{
    //     console.log(sessionStorage.getItem('aabb'));
    //     console.log(res);
    //     this.visible=false
    //     this.filePag=null
    //   })
    // },



    handleChange(info) {
      // if(info.fileList.length==1) return this.$message('一次只能上传一张图片')
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
      this.getBasicInfo()
    },
    beforeUpload(file) {
      this.data.picture=file
      this.actionUrl += "?a00="+ sessionStorage.getItem('aabb')
      const isJpgOrPng = file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('你只能上传png格式的文件');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('文件大小不能超过2m');
      }
      return isJpgOrPng && isLt2M;
    },

   getBit (value, bit) {
      let str = Number(value);
      str = str.toFixed(bit)
      console.log(str)
      return str;
  },

  //禁止输入负数
  proving2(e) {
            // console.log(e.target.value)
            // console.log(this.getBit(e.target.value,1))
            var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
            var keychar = String.fromCharCode(keynum);  //获取键盘码对应的字符
            if (keynum ==189||keynum == 109) { //禁止输入负数
              this.$message.warning('禁止输入负数')
              e.target.value = 0
            }
  },



    //查询代码表
    //政治面貌
    getzzmm(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB4762'
        }
      },(res)=>{
        if(res.code=200){
          this.Political=res.data
        }
      })
    },



    //性别
    getxb(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22611'
        }
      },(res)=>{
        if(res.code==200){
          this.sexList=res.data
        }
      })
    },

    //民族
    getmz(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB3304'
        }
      },(res)=>{
        if(res.code==200){
          this.nations=res.data
        }
      })
    },

    //婚姻
    gethy(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22612'
        }
      },(res)=>{
        if(res.code==200){
          this.marriage=res.data
        }
      })
    },

    //健康状态
    getjk(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22613'
        }
      },(res)=>{
        if(res.code==200){
          this.healthy=res.data
        }
      })
    },

    //与本人关系
    getgx(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB4761'
        }
      },(res)=>{
        if(res.code==200){
          this.relation=res.data
        }
      })
    },

     // 学历
    getxl(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'BJ012'
        }
      },(res)=>{
        if(res.code=200){
          this.educationList=res.data
        }
      })
    },
    // 学位
    getxw(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB6864'
        }
      },(res)=>{
        if(res.code=200){
          this.academic=res.data
        }
      })
    },
    // 教育类型
    getjylx(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'BJ011'
        }
      },(res)=>{
        if(res.code=200){
          this.Education=res.data
        }
      })
    },
    // 学制
    getxz(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GKZP_DM_09'
        }
      },(res)=>{
        if(res.code=200){
          this.system=res.data
        }
      })
    },



  },

  created(){
    this.getxb()
    this.gethy()
    this.getjk()
    this.getmz()
    this.getzzmm()
    this.getgx()
    this.getxl()
    this.getxw()
    this.getjylx()
    this.getxz()


  },

  mounted(){
    var that=this
    setTimeout(function(){
      that.getBasicInfo()
    that.getShzpInfo()
    that.getYjbysInfo()
    that.getLearningExperienceByA00()
    that.getFamilyNumbersByA00()
    that.getWorkExperienceByA00()
    },0)
    const device = navigator.userAgent
    if (device.indexOf('iPad') > -1) {
      //  ipad 
      this.userAgent = 'ipad'
      this.ifPhone = true
      } else if (device.indexOf('Android') > -1 || device.indexOf('ios') > -1) {
      // 手机
      this.userAgent = 'phone'
      this.ifPhone = true
      } else {
      // 电脑
      this.ifPhone = false
      this.userAgent = 'pc'
      }
  }
}
</script>






<style scoped>
li{
  list-style: none;
}
.container{
  display: flex;
}

.left{
  width:294px
}
.pic{
  height: 190px;
  border: 1px solid #d2d2d2;
  background-color: #fff;
  position: relative;
}
.pics{
  display: flex;
}
.pics img{
  border: none;
  width: 84px;
  height: 106px;
  position: absolute;
  top: 16px;
  left: 16px;
}
.pics .name{
  font-size: 18px;
  color: #000;
  position: absolute;
  top: 60px;
  right: 16px;
}
.pic .date{
  font-size: 12px;
  color: #acabab;
  position: absolute;
  top: 100px;
  right: 16px;
}

.pic ul{
    width: 100%;
    height: 50px;
    border-top: 1px solid #d2d2d2;
    background-color: #e3eeff;
    position: absolute;
    bottom: -14px;
}
.pic ul li{
    float: left;
    line-height: 50px;
    cursor: pointer;
    color: #0053c5;
    text-align: center;
    width: 33.3%;
}
.jianli{
    border: 1px solid #d2d2d2;
    margin-top: 20px;
    background-color: #fff;
}
.jianli h4{
    padding-left: 10px;
    font-size: 16px;
    color: #fff;
    height: 40px;
    background-color: #0053c5;
    line-height: 40px;
}
.jianli ul li{
    height: 40px;
    line-height: 40px;
    color: #706e6e;
    padding-left: 10px;
    cursor: pointer;
}

.right{
  border: 1px solid #c1d7f9;
  background-color: #e3eeff;
  margin-left: 10px;
  width: 682px;
}

.ryjbxxTitle{
  width: 128px;
  height: 30px;
  background: #CC0000;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: #FEFEFE;
  margin:10px auto 0;
  font-size: 16px;
}

.remarks{
  font-size: 14px;
  color: red;
  font-weight: bold;
  text-align: center;
  background-color: #E3EFFF;
  border-bottom:1px solid #C1D7F9;
  padding: 15px;
}

.messages{
  overflow: hidden;
  background-color: #e3efff;
  width: 100%;
}
/deep/ .msgpc .ant-form-item .ant-form-item-control-wrapper{
  display: block;
  width: 50%!important;
}
/deep/ .msgpc .ant-form-item .ant-form-item-label{
  display: block;
  width: 30%!important;
}
.btns{
  display: block;
  position: relative;
  height: 50px;
  border: 1px solid #c1d7f9;
  background-color: #e3eeff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btns button{
    width: 84px;
    height: 36px;
    background-color: #f1a338;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    border: none;
    border-radius: 4px;
}

.btns button:hover{
  cursor: pointer;
}


.adds{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background-color: #EFF5FD;
  font-size: 16px;
}

.adds div:hover{
  cursor: pointer;
}

.adds button:hover{
  cursor: pointer;
}

.adds div{
  width: 25px;
  height: 25px;
  background-color: #c00000;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: white;
  font-weight: blod;
  margin-right: 5px;
}

.adds button{
  color: #c00000;
  background-color: #EFF5FD;
  border:none;
  font-size: 16px;
}

.picc{
     width: 195px;
    height: 273px;
    margin-left: 42px;
    border: 1px solid #ACACAC;
    display: block;
    margin: 0 auto;
}

.imgAvatar{
  max-width: 400px;
}

.cm{
  position: absolute;
  bottom: -10px;
  left: 200px;
}
/* /deep/ .avatar-uploader{
  margin: auto
} */
/deep/ th{
  padding: 5px 3px !important;
  text-align: center !important;
}

/deep/ .ant-btn-primary{
  background-color: #fff;
  border-color: #fff;
  color: #0053c5;
  text-shadow: none;
  box-shadow: none;
}

/deep/ .ant-table-tbody > tr > td {
  background-color: #fff;
  text-align: center !important;
  padding: 5px 3px !important; ;
  max-width: 80px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .ant-table-tbody{
  background-color: #fff;
}

/deep/ .ant-table-body td{
  text-overflow:ellipsis;
  text-align: center;
}

/deep/ .ant-table-row {
  padding: 5px 0!important;
}

/deep/ .ant-modal-content th{
  text-align: center!important;
  padding: 0px 10px !important;
}

/deep/ .ant-modal-content td{
  text-align: center!important;
  padding: 0px 0px !important;
  width: 80px!important;
}

/deep/ .ant-col{
  height: 50px!important;
  font-size: 16px!important;
}

/deep/ .ant-modal-content{
  height: 700px;
  width: 700px;
}

/deep/ .txtarea .ant-form-item-control{
  width: 506px!important;
}

.txtarea{
  margin-bottom: 90px;
  margin-top: 20px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
     -webkit-appearance: none;
}

input[type="number"] {
      -moz-appearance: textfield;
}

/deep/ .ant-upload-text{
  display: none;
}


</style>



// WEBPACK FOOTER //
// src/views/wdjl/pages/index.vue